import React from "react";
import { Link } from "react-router-dom";

import AlexNImg from "@/assets/images/alex-n.png";
import AlexanderMImg from "@/assets/images/alexander-m.png";
import AlexanderRImg from "@/assets/images/alexander-r.png";
import CarlEmilKImg from "@/assets/images/carl-emil-k.png";
import VladislavsGImg from "@/assets/images/vladislavs-g.png";
import AndersSImg from "@/assets/images/anders-s.png";
import AntonAImg from "@/assets/images/anton.png";
import ArunRImg from "@/assets/images/arun-r.png";
import FelixTImg from "@/assets/images/felix.png";
import JoenMImg from "@/assets/images/joen.png";
import MarcelUImg from "@/assets/images/marcel.png";
import NilsBImg from "@/assets/images/nils.png";
import MarkusRImg from "@/assets/images/markus-r.png";
import MartinLImg from "@/assets/images/martin-l.png";
import SebastianAImg from "@/assets/images/sebastian-a.png";
import JohanImg from "@/assets/images/johan-r.png";
import JohannesTImg from "@/assets/images/johannes-t.png";
import LyupchoKImg from "@/assets/images/lyupchu-k.png";
import MagnusCImg from "@/assets/images/magnus-c.png";
import MarieImg from "@/assets/images/marie-c.png";
import NellLImg from "@/assets/images/nell-l.png";
import PatrickFImg from "@/assets/images/patrick-f.png";
import PatrikPImg from "@/assets/images/patrik-p.png";
import PatrikRImg from "@/assets/images/patrik-r.png";
import PhilipPImg from "@/assets/images/philip-p.png";
import ThomasBImg from "@/assets/images/thomas-b.png";
import TomasBImg from "@/assets/images/tomas-b.png";
import ViktorNImg from "@/assets/images/viktor-n.png";
import VincentLImg from "@/assets/images/vincent-l.png";
import WilliamPImg from "@/assets/images/william-p.png";
import JerryHImg from "@/assets/images/jerry-h.png";

type CVEntry = {
  name: string;
  title: string;
  photo?: string;
  path: string;
};

type CVGroup = {
  label: string;
  members: CVEntry[];
};

const GROUPS: CVGroup[] = [
  {
    label: "Team Lead & Project Management",
    members: [
      { name: "Alexander Nyberg", title: "Enterprise Architect · Interim CIO", photo: AlexNImg, path: "/cv/alexander-nyberg" },
      { name: "Anders Söderlin", title: "Group CIO · Transformation & Change Leader", photo: AndersSImg, path: "/cv/anders-soderlin" },
      { name: "Martin Levin", title: "Senior Program & Project Manager · Agile Product Owner", photo: MartinLImg, path: "/cv/martin-levin" },
      { name: "Sebastian Andersson", title: "Scrum Master · Agile Coach", photo: SebastianAImg, path: "/cv/sebastian-andersson" },
      { name: "Marie Coletti", title: "Team Lead & Project Manager", photo: MarieImg, path: "/cv/marie-coletti" },
      { name: "Thomas Bergström", title: "Senior Interim Manager · Project/Program Manager", photo: ThomasBImg, path: "/cv/thomas-bergstrom" },
    ],
  },
  {
    label: "UX Design",
    members: [
      { name: "Johan Rosengren", title: "Senior UX Designer", photo: JohanImg, path: "/cv/johan-rosengren" },
    ],
  },
  {
    label: "Data & Analytics",
    members: [
      { name: "Marcel Urrutia Nilsson", photo: MarcelUImg, title: "Senior ML Engineer", path: "/cv/marcel-urrutia-nilsson" },
      { name: "Nell Levasseur", title: "Data & BI Specialist", photo: NellLImg, path: "/cv/nell-levasseur" },
      { name: "Nils Broman", photo: NilsBImg, title: "ML Engineer, M.Sc.", path: "/cv/nils-broman" },
      { name: "Vladislavs Gaidašs", photo: VladislavsGImg, title: "Data & Data Platform Engineer", path: "/cv/vladislavs-gaidass" },
    ],
  },
  {
    label: "Development",
    members: [
      { name: "Alexander Madsen", photo: AlexanderMImg, title: "Senior Frontend Developer", path: "/cv/alexander-madsen" },
      { name: "Alexander Raunert", photo: AlexanderRImg, title: "Frontend Developer", path: "/cv/alexander-raunert" },
      { name: "Anton Alfsson", photo: AntonAImg, title: "Software Developer", path: "/cv/anton-alfsson" },
      { name: "Arun Rathi", photo: ArunRImg, title: "Senior Android Engineer", path: "/cv/arun-rathi" },
      { name: "Carl-Emil Kjellstrand", photo: CarlEmilKImg, title: "Senior Software Developer · Android & Kotlin", path: "/cv/carl-emil-kjellstrand" },
      { name: "Felix Tran", photo: FelixTImg, title: "Senior Platform Engineer · DevOps", path: "/cv/felix-tran" },
      { name: "Joen Mauritzon", photo: JoenMImg, title: "iOS Developer", path: "/cv/joen-mauritzon" },
      { name: "Jerry Hon", photo: JerryHImg, title: "Senior Frontend & Fullstack Developer", path: "/cv/jerry-hon" },
      { name: "Johannes Tegnér", title: "Developer", photo: JohannesTImg, path: "/cv/johannes-tegner" },
      { name: "Lyupcho Kotev", title: "Developer & Platform Engineer", photo: LyupchoKImg, path: "/cv/lyupcho-kotev" },
      { name: "Magnus Christiansson", title: "Developer & Platform Engineer", photo: MagnusCImg, path: "/cv/magnus-christiansson" },
      { name: "Markus Rytterkull", title: "Developer", photo: MarkusRImg, path: "/cv/markus-rytterkull" },
      { name: "Patrick Fogwall", title: "Architect & Full-Stack Developer", photo: PatrickFImg, path: "/cv/patrick-fogwall" },
      { name: "Patrik Pochill", title: "Architect & Full-Stack Developer", photo: PatrikPImg, path: "/cv/patrik-pochill" },
      { name: "Patrik Rizell", title: "Developer", photo: PatrikRImg, path: "/cv/patrik-rizell" },
      { name: "Philip Persson", title: "Developer", photo: PhilipPImg, path: "/cv/philip-persson" },
      { name: "Tomas Boremalm", title: "Senior Software Engineer & Solution Architect", photo: TomasBImg, path: "/cv/tomas-boremalm" },
      { name: "Viktor Nilsson", title: "Developer", photo: ViktorNImg, path: "/cv/viktor-nilsson" },
      { name: "William Phan", title: "Fullstack Developer & DevOps Engineer", photo: WilliamPImg, path: "/cv/william-phan" },
      { name: "Vincent Lam", title: "Full-Stack Developer", photo: VincentLImg, path: "/cv/vincent-lam" },
    ],
  },
];

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export default function CVIndexPage() {
  React.useEffect(() => {
    document.title = "BoldBrave CVs";

    // noindex, nofollow
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
    }
    meta.content = "noindex, nofollow";

    return () => {
      if (meta) meta.remove();
    };
  }, []);

  return (
    <section className="py-14">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold mb-2">BoldBrave CVs</h1>
        <p className="text-white/70 mb-10">
          Select a team member to view their full CV.
        </p>

        {GROUPS.map((group) => (
          <div key={group.label} className="mb-10">
            <h2 className="text-lg font-semibold text-white/90 mb-4">{group.label}</h2>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {group.members.map((cv) => (
                <Link
                  key={cv.path}
                  to={cv.path}
                  className="flex items-center gap-4 rounded-2xl bg-[#0f1a18] border border-white/10 p-5 hover:border-[#FF893F] transition"
                >
                  {cv.photo ? (
                    <img
                      src={cv.photo}
                      alt={cv.name}
                      className="h-14 w-14 rounded-full object-cover shrink-0 bg-[#152D2B] ring-1 ring-white/10"
                    />
                  ) : (
                    <div
                      aria-label={cv.name}
                      className="h-14 w-14 rounded-full shrink-0 bg-[#152D2B] ring-1 ring-white/10 flex items-center justify-center text-sm font-semibold text-white/80"
                    >
                      {initialsOf(cv.name)}
                    </div>
                  )}
                  <div className="min-w-0">
                    <p className="font-semibold truncate">{cv.name}</p>
                    <p className="text-sm text-white/70 truncate">{cv.title}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
